module.exports = __webpack_public_path__ + "static/matrix1-9f7dcd38918f941fd5fe429d920c005c.jpg";